import { useMemo } from 'react';

import { ICalendarEvent, google, ics, office365, yahoo, outlook } from '@/lib/calendar-link/index';

interface IAddToCalendarLinks {
  google: string;
  office365: string;
  ics: string;
  yahoo: string;
  outlook: string;
}

export function useAddEventToCalendarLinks(data): IAddToCalendarLinks {
  const { name: title, startUtc, endUtc, location = 'Underline', ...rest } = data;

  return useMemo(() => {
    const calendarEvent: ICalendarEvent = {
      title,
      startUtc,
      endUtc,
      location,
      ...rest,
    };

    return {
      google: google(calendarEvent),
      office365: office365(calendarEvent),
      ics: ics(calendarEvent),
      yahoo: yahoo(calendarEvent),
      outlook: outlook(calendarEvent),
    };
  }, [title, startUtc, endUtc, location, rest]);
}
